<template>
  <div class="topbox">
    <div class="cont">
      <router-link to="/"><img src="../../assets/img/logo.png"
             alt=""
             class="logo"></router-link>
      <ul class="nav">
        <li v-for="(item,i) in list"
            :key="i"
            :class="currentIndex == i && $route.path.search('detail') == -1 ? 'on' : ''"
            @click="handleIndex(item,i)">{{item.name}}</li>
        <el-dropdown class="morelinks"
                     trigger="click">
          <div class="more">...</div>
          <el-dropdown-menu slot="dropdown"
                            class="moreselect">
            <!-- <el-dropdown-item><a href="http://jinghe.yysmart.cn:9112"
                 target="_blank">药育精合产业培训教育平台</a></el-dropdown-item>
            <el-dropdown-item><a href="http://jinghe.yysmart.cn:9112/jinghe/index.html"
                 target="_blank">药育精合官网</a></el-dropdown-item> -->
            <el-dropdown-item><a href="http://www.autof.cn/"
                 target="_blank">钟山虚拟现实技术研究院</a></el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </ul>
    </div>

  </div>
</template>

<script>
export default {
  props: ['index'],
  data () {
    return {
      isIndex: this.$route.path === '/',
      list: [
        { name: '药育智能', router: '/', ref: 'banner' },
        { name: '智慧教育云平台', router: 'http://www.yysmart.cn:9113/', ref: '' },
        { name: '药育本草', router: '/yybc/index', ref: 'yybc', push: true },
        { name: '产品案例', router: '/product/index', ref: 'product', push: true },
        { name: '新闻资讯', router: '/news/index', ref: 'news', push: true },
        { name: '合作院校', router: '/?ref=cooperative&index=5', ref: 'cooperative' },
        // { name: '直采专区', router: '/purchase/index', ref: 'purchase', push: true },
        { name: '联系我们', router: '/?ref=bottom&index=6', ref: 'bottom' },
      ],
      currentIndex: this.index
    }
  },
  created () {

    if (!this.index) {
      // 只有首页会给props传值index，这是在其他页面
      const index = this.list.findIndex(v => v.router === this.$route.path)
      this.currentIndex = index === -1 ? 0 : index
    }
  },
  computed: {
  },
  methods: {
    handleIndex (item, index) {
      if (!item.ref) {
        // 外部链接跳转
        window.open(item.router)
        return
      }
      this.currentIndex = index
      if (this.isIndex && !item.push) {
        // 首页有模块跳转，就派发事件(push为true是跳转页面)
        this.$emit('move', item.ref)
        return
      }
      this.$router.push(item.router)
    }
  }
}
</script>

<style lang="scss" scoped>
.topbox {
  height: 80px;
  background: rgba(1, 1, 1, 0.3);
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  .cont {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .nav {
      display: flex;
      li {
        font-size: 18px;
        margin: 0 20px;
        line-height: 78px;
        color: #fff;
        cursor: pointer;
        &.on,
        &:hover {
          color: $themeColor;
          font-weight: bold;
        }
        &.on {
          border-bottom: 2px solid $themeColor;
        }
        &.on:after {
          content: "";
          display: block;
        }
      }
      .more {
        cursor: pointer;
        font-size: 30px;
        color: #fff;
        padding: 0 10px 18px;
        margin-top: 14px;
        margin-left: 20px;
        &:hover {
          color: $themeColor;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.moreselect {
  .popper__arrow {
    display: none;
  }
  &.el-dropdown-menu {
    background: #f1f4fa;
    text-align: right;
    margin-top: 0;
    padding: 0;
    border: 0;
    border-radius: 0;
    box-shadow: 15px 0px 53px 6px rgba(105, 124, 167, 0.18);
    .el-dropdown-menu__item {
      font-size: 16px;
      color: #363131;
      height: 50px;
      line-height: 50px;
      &:hover {
        background-color: $themeColor;
        font-weight: 600;
      }
    }
  }
}
</style>